/**
 * Custom React.memo compare for inventory tab pages mounted inside InventoryTabPanel.
 * Inactive tabs stay mounted but hidden; skip reconcile when deactivating or while hidden.
 */
export function inventoryTabPropsAreEqual(prev, next) {
  if (prev.setSearchParams !== next.setSearchParams) return false;

  if (!next.isTabActive) {
    return true;
  }

  if (prev.isTabActive !== next.isTabActive) return false;
  return prev.searchParams === next.searchParams;
}

export function certifiedInventoryPropsAreEqual(prev, next) {
  if (prev.colorCategory !== next.colorCategory) return false;
  return inventoryTabPropsAreEqual(prev, next);
}
